import React, { useContext, useEffect, useRef, useState } from "react";
import { Form, Formik, FormikHelpers } from "formik";
import { connect } from "react-redux";
import { ONBOARDING_STEPS, ROUTES, VIEWS } from "../constants/user-info.const";
import StateTaxesForm from "./user-forms/StateTaxesForm";
import {
  getStateTaxes,
  postStateTaxes,
} from "../../services/api-services/stateTaxService";
import Loader from "../common/Loader";
import store from "../../store";
import { showAlert } from "../../store/actions/feedback";
import { AppContext } from "../routing/Routing";
import { useNavigate } from "react-router-dom";
import {
  createFormAnswers,
  createValidationSchema,
  initializeForm,
} from "../common/stateTaxesFormFieldsFormatter";
import { onboardingActions } from "../../store/actions/steps";
import { formSubmitErrorHandler } from "../../services/formService";

function StateTaxes(props: any) {
  const [validationSchema, setValidationSchema] = useState({});
  const [loading, setLoading] = useState(false);
  const [employeeData, setEmployeeData] = useState<any>({});
  const [intialFormValues, setInitialFormValues] = useState<any>({});
  const { setViewName } = useContext(AppContext);
  const [employeeStateId, setEmployeeStateId] = useState("");
  const [employeeState, setEmployeeState] = useState<any>([]);
  const { usStates, isNavigateToNext } = props;
  const mountedRef = useRef(true);
  const [isShowFooterLoader, setIsShowFooterLoader] = useState(false);
  const navigate = useNavigate();

  const navigateToPayments = () => {
    if (isNavigateToNext === false) return;
    setViewName(VIEWS.paymentMethod);
    navigate(ROUTES.paymentMethod);
  };
  const dispatchErrorToStore = (error: string) => {
    store.dispatch(
      showAlert({
        alertType: "error",
        alertText: error,
      })
    );
  };
  const updateCompletedStep = () => {
    store.dispatch({
      type: onboardingActions.UPDATE_ONBOARDING_STEPS,
      state: ONBOARDING_STEPS.stateTaxes,
    });
  };
  const onSubmit = (formData: unknown, formHelpers: FormikHelpers<any>) => {
    const data = createFormAnswers(formData, employeeData);
    setIsShowFooterLoader(true);
    formSubmitErrorHandler(
      postStateTaxes(data).then((data) => {
        setIsShowFooterLoader(false);
        initializeFormValues(data);
        updateCompletedStep();
        navigateToPayments();
        formHelpers.resetForm();
      }),
      () => {
        setIsShowFooterLoader(false);
      },
      formHelpers.setFieldError
    );
  };
  const showErrorMessage = (error) => {
    const errorMessage = error.status?.message;
    dispatchErrorToStore(errorMessage);
  };

  const createNewValidationSchema = (data: any) => {
    const schema: any = createValidationSchema(data);
    setValidationSchema(schema);
  };

  const initializeFormValues = (data: any) => {
    const formValues = initializeForm(data?.data);
    setInitialFormValues(formValues);
  };
  const initializeEmployeeState = (stateAbbr: string) => {
    usStates.forEach((state) => {
      if (state.id === stateAbbr) {
        const stateObj = [
          {
            id: state.id,
            abbr: state.abbr,
            name: state.name,
          },
        ];
        setEmployeeState(stateObj);
      }
    });
  };
  useEffect(() => {
    if (usStates) {
      initializeEmployeeState(employeeStateId);
    }
  }, [employeeStateId]);
  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);
  useEffect(() => {
    setLoading(true);
    getStateTaxes()
      .then((data: any) => {
        if (!mountedRef.current) return null;
        setEmployeeData(data?.data);
        setEmployeeStateId(data?.data?.state);
        createNewValidationSchema(data);
        initializeFormValues(data);
        setLoading(false);
      })
      .catch((error) => {
        if (!mountedRef.current) return null;
        setLoading(false);
        showErrorMessage(error);
      });
  }, []);
  return (
    <div className="state-taxes">
      <Formik
        initialValues={intialFormValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
        enableReinitialize
        innerRef={props.formRef}
      >
        {() => {
          return (
            <div className="state-taxes">
              <Form>
                <div className="user-details--section">
                  {loading ? (
                    <Loader />
                  ) : (
                    <>
                      <StateTaxesForm
                        employeeData={employeeData}
                        employeeState={employeeState}
                      />
                      {isShowFooterLoader && <Loader footerLoader={true} />}
                    </>
                  )}
                </div>
              </Form>
            </div>
          );
        }}
      </Formik>
    </div>
  );
}
const mapStateToProps = (state) => ({
  usStates: state.config?.employees?.states,
  isNavigateToNext: state.navigationFromMenu.isNavigateToNext,
});
export default connect(mapStateToProps)(StateTaxes);
